import { LazyImage } from "@piperunner-cms/component/LazyImage";
import { AlignmentContainer, CaptionContainer } from "@piperunner-cms/component/RTERenderer/common";
import type { NodeProps } from "@tiptap/static-renderer/json/react";
import type { ImageAttributes } from "../type";
import styles from "./ImageNodeView.module.css";

export default function ImageNodeView({ node }: NodeProps) {
  const { src, width, maxWidth, minWidth, align, allowfullscreen, alt, aspectRatio, caption, placeholder } =
    node.attrs as ImageAttributes;

  return (
    <AlignmentContainer
      align={align}
      wrapperStyle={{
        width,
        maxWidth,
        minWidth,
        aspectRatio,
      }}
    >
      <CaptionContainer caption={caption} className="w-full h-full">
        <LazyImage src={src} alt={alt} className={styles.imageStyles} placeholder={placeholder} />
      </CaptionContainer>
    </AlignmentContainer>
  );
}
